var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFinsus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.93,
    height: 32.293,
    viewBox: "0 0 104.93 32.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23223f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#312640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ff5f54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5f54"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_oscuro_vectorial",
    transform: "translate(-668.45 -309.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26356",
    "data-name": "Grupo 26356",
    transform: "translate(668.45 309.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26354",
    "data-name": "Grupo 26354",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7405",
    "data-name": "Trazado 7405",
    d: "M51.981,16.569q2.62,2.558,2.62,7.375V37.595H50.8v-13.1a7.448,7.448,0,0,0-1.733-5.3,6.191,6.191,0,0,0-4.734-1.839,6.339,6.339,0,0,0-4.839,1.9,7.77,7.77,0,0,0-1.8,5.536V37.595H33.85V14.435H37.7v3.3A7.642,7.642,0,0,1,40.8,14.984a9.634,9.634,0,0,1,4.331-.972,9.387,9.387,0,0,1,6.847,2.557",
    transform: "translate(-12.82 -5.306)",
    fill: "#23223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7406",
    "data-name": "Trazado 7406",
    d: "M75.461,36.478a8.048,8.048,0,0,1-3.339-2.536A6.74,6.74,0,0,1,70.77,30.2h3.973a3.9,3.9,0,0,0,1.626,2.832,6.181,6.181,0,0,0,3.825,1.1,5.57,5.57,0,0,0,3.466-.972,2.971,2.971,0,0,0,1.267-2.451,2.417,2.417,0,0,0-1.353-2.261,19.02,19.02,0,0,0-4.184-1.458,30.683,30.683,0,0,1-4.206-1.374A7.454,7.454,0,0,1,72.4,23.546a5.4,5.4,0,0,1-1.162-3.614,5.476,5.476,0,0,1,1.057-3.254,7.159,7.159,0,0,1,3-2.345,10.79,10.79,0,0,1,4.439-.867,9.475,9.475,0,0,1,6.213,1.945,7,7,0,0,1,2.535,5.325H84.633a3.974,3.974,0,0,0-1.458-2.916,5.437,5.437,0,0,0-3.571-1.1,5.5,5.5,0,0,0-3.3.888,2.742,2.742,0,0,0-1.226,2.324,2.544,2.544,0,0,0,.739,1.881A5.389,5.389,0,0,0,77.68,23a31.818,31.818,0,0,0,3.106.993,33.492,33.492,0,0,1,4.058,1.331,7.111,7.111,0,0,1,2.684,1.965A5.261,5.261,0,0,1,88.69,30.71a5.864,5.864,0,0,1-1.057,3.423,7.046,7.046,0,0,1-2.98,2.388,10.66,10.66,0,0,1-4.417.867,11.979,11.979,0,0,1-4.776-.909",
    transform: "translate(-26.802 -5.097)",
    fill: "#23223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7407",
    "data-name": "Trazado 7407",
    d: "M123.888,14.15V37.31h-3.846V33.887a7.49,7.49,0,0,1-3.064,2.768,9.474,9.474,0,0,1-4.332.993,10.382,10.382,0,0,1-4.861-1.12,8.136,8.136,0,0,1-3.4-3.361,11.057,11.057,0,0,1-1.246-5.453V14.15h3.8V27.21a7.381,7.381,0,0,0,1.733,5.261,6.192,6.192,0,0,0,4.734,1.838,6.325,6.325,0,0,0,4.86-1.9,7.828,7.828,0,0,0,1.775-5.537V14.15Z",
    transform: "translate(-39.062 -5.359)",
    fill: "#23223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7408",
    "data-name": "Trazado 7408",
    d: "M144.745,36.478a8.051,8.051,0,0,1-3.34-2.536,6.745,6.745,0,0,1-1.352-3.74h3.972a3.9,3.9,0,0,0,1.626,2.832,6.181,6.181,0,0,0,3.825,1.1,5.571,5.571,0,0,0,3.466-.972,2.971,2.971,0,0,0,1.267-2.451,2.417,2.417,0,0,0-1.353-2.261,19.018,19.018,0,0,0-4.184-1.458,30.677,30.677,0,0,1-4.206-1.374,7.453,7.453,0,0,1-2.789-2.071,5.4,5.4,0,0,1-1.162-3.614,5.471,5.471,0,0,1,1.057-3.254,7.163,7.163,0,0,1,3-2.345,10.791,10.791,0,0,1,4.438-.867,9.476,9.476,0,0,1,6.213,1.945,7,7,0,0,1,2.535,5.325h-3.846a3.974,3.974,0,0,0-1.458-2.916,5.439,5.439,0,0,0-3.571-1.1,5.505,5.505,0,0,0-3.3.888,2.742,2.742,0,0,0-1.225,2.324,2.544,2.544,0,0,0,.739,1.881A5.39,5.39,0,0,0,146.963,23a31.8,31.8,0,0,0,3.106.993,33.488,33.488,0,0,1,4.058,1.331,7.11,7.11,0,0,1,2.684,1.965,5.258,5.258,0,0,1,1.162,3.423,5.863,5.863,0,0,1-1.056,3.423,7.045,7.045,0,0,1-2.98,2.388,10.66,10.66,0,0,1-4.417.867,11.979,11.979,0,0,1-4.776-.909",
    transform: "translate(-53.042 -5.098)",
    fill: "#23223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7409",
    "data-name": "Trazado 7409",
    d: "M14.2,12.986H6.847v19.3H3v-19.3H0V9.128H3V7.481Q3,3.593,5.01,1.8T11.454,0V3.212A5.109,5.109,0,0,0,7.882,4.2,4.388,4.388,0,0,0,6.847,7.481V9.129H14.2Z",
    transform: "translate(0 0)",
    fill: "#23223f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26355",
    "data-name": "Grupo 26355",
    transform: "translate(14.999 13.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_12887",
    "data-name": "Rect\\xE1ngulo 12887",
    width: 3.845,
    height: 18.428,
    transform: "translate(3.845 18.428) rotate(180)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_12888",
    "data-name": "Rect\\xE1ngulo 12888",
    width: 3.846,
    height: 3.857,
    transform: "translate(14.998 9.13)",
    fill: "#ff5f54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinsus);
export default __webpack_public_path__ + "static/media/logo_finsus.0e2c617b3f8485fef964a869c2ae965b.svg";
export { ForwardRef as ReactComponent };